export enum GroupChatConversationType {
  PublicGroup = 'PublicGroup',
  PrivateUsers = 'PrivateUsers',
}

export enum GroupChatMessageType {
  Normal = 'Normal',
  UserLeft = 'UserLeft',
}
